// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Admin Layout — light sidebar, clean topbar, content area
   ============================================================ */
:root {
  /* #e05a2b measured 3.7:1 under white button text; this is 5.4:1 */
  --admin-rust: #b8441a;
  --admin-rust-dk: #9a3915;
  /* Same colour as channels, so tints can be built from it at runtime.
     admin/brand.js repaints all three from the API. */
  --admin-rust-rgb: 184, 68, 26;
  --admin-rust-soft: #d0633a;
  --admin-forest: #1a2818;
  --admin-sidebar: #1a2818;
  --admin-bg: #f4efe6;
  --admin-surface: #faf7f2;
  --admin-border: #ddd5c8;
  --admin-text: #1b1b1b;
  --admin-muted: #6b6258;
  --admin-green: #16a34a;
  --admin-amber: #d97706;
  --admin-blue: #2563eb;
  --admin-red: #dc2626;
  --admin-purple: #7c3aed;
  --admin-sidebar-w: 232px;
  --admin-topbar-h: 64px;
}

.al {
  display: flex;
  min-height: 100dvh;
  background: var(--admin-bg);
  font-family: var(--font-body);
}

/* ══════════════════════════════════════════════
   SIDEBAR
══════════════════════════════════════════════ */
.al__sidebar {
  width: var(--admin-sidebar-w);
  background: var(--admin-sidebar);
  background-image: radial-gradient(ellipse at 50% 100%, rgba(56, 70, 56, 0.6) 0%, transparent 60%);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 200;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0 0.5rem;
  /* The nav scrolls, not the whole sidebar (V2.1): the logo stays put. */
  overflow: hidden;
  transition: width 0.2s ease;
}

.al__logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;
  margin: 0 1rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.al__logo-words {
  display: flex;
  flex-direction: column;
}
.al__logo-name {
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.2em;
  color: #fff;
  line-height: 1.1;
}
.al__logo-sub {
  font-size: 0.5rem;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  line-height: 1.35;
}

.al__nav {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1 1;
  min-height: 0;
  margin-top: 1rem;
  padding: 0.25rem 0.6rem 1rem 1rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  /* A scrollbar you can see (V2.1, Page 1), thin and quiet on the dark green */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.28) transparent;
  scrollbar-gutter: stable;
}
.al__nav::-webkit-scrollbar { width: 8px; }
.al__nav::-webkit-scrollbar-track { background: transparent; }
.al__nav::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.22); border-radius: 8px; border: 2px solid var(--admin-sidebar); }
.al__nav::-webkit-scrollbar-thumb:hover { background: rgba(255, 255, 255, 0.4); }

.al__nav-link {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.62rem 0.8rem;
  border-radius: 6px;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  transition:
    background 0.15s,
    color 0.15s;
  position: relative;
  letter-spacing: 0.01em;
}
.al__nav-link:hover {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.85);
}
.al__nav-link--active {
  background: rgba(var(--admin-rust-rgb), 0.18);
  color: var(--admin-rust) !important;
  font-weight: 600;
}
.al__nav-link--active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 22%;
  bottom: 22%;
  width: 3px;
  background: var(--admin-rust);
  border-radius: 0 2px 2px 0;
}
.al__nav-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

/* Sidebar user */
.al__sidebar-user {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.85rem 0.5rem;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

.al__sidebar-avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0.03em;
}

.al__sidebar-user-name {
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
}
.al__sidebar-user-role {
  font-size: 0.62rem;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}
.al__sidebar-user-info {
  flex: 1 1;
  min-width: 0;
}

.al__sidebar-user-chevron {
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.35);
  font-size: 0.6rem;
  padding: 0.2rem;
  flex-shrink: 0;
}
.al__sidebar-user-chevron:hover {
  color: rgba(255, 255, 255, 0.7);
}

.al__sidebar-badge {
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  scale: 0.8;
}

/* ══════════════════════════════════════════════
   MAIN AREA
══════════════════════════════════════════════ */
.al__main {
  flex: 1 1;
  /* A flex item's min-width is \`auto\`, which means "never narrower than my
     widest unbreakable content". One long line inside a card was enough to
     push the whole page wider than a tablet screen and put the row's
     buttons out of reach, so this lets it shrink instead. */
  min-width: 0;
  margin-left: var(--admin-sidebar-w);
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

/* Topbar */
.al__topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  border-bottom: 1px solid var(--admin-border);
  height: var(--admin-topbar-h);
  display: flex;
  align-items: center;
  padding: 0 clamp(1rem, 3vw, 2rem);
  gap: 1rem;
}

.al__topbar-menu {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: var(--admin-text);
  padding: 0.25rem;
  flex-shrink: 0;
}

.al__topbar-spacer {
  flex: 1 1;
}

/* Bell */
.al__topbar-bell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text);
  font-size: 1.1rem;
  text-decoration: none;
  padding: 0.35rem;
  transition: color 0.15s;
}
.al__topbar-bell:hover {
  color: var(--admin-rust);
}
.al__bell-badge {
  position: absolute;
  top: -3px;
  right: -3px;
  background: var(--admin-rust);
  color: #fff;
  font-size: 0.52rem;
  font-weight: 700;
  min-width: 1rem;
  height: 1rem;
  border-radius: 99px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.2rem;
}

/* Topbar user */
.al__topbar-user {
  position: relative;
}

.al__topbar-user-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
}

.al__topbar-avatar {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  background: var(--admin-forest);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* Slight gradient */
  background: linear-gradient(135deg, #4a5e42 0%, var(--admin-forest) 100%);
}

.al__topbar-avatar--lg {
  width: 2.6rem;
  height: 2.6rem;
  font-size: 0.82rem;
}

.al__topbar-user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.al__topbar-user-name {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--admin-text);
  line-height: 1.2;
}
.al__topbar-user-role {
  font-size: 0.72rem;
  color: var(--admin-muted);
  line-height: 1.2;
}

.al__topbar-chevron {
  font-size: 0.65rem;
  color: var(--admin-muted);
  transition: transform 0.2s;
}

/* Dropdown */
.al__profile-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  overflow: hidden;
  z-index: 300;
}
.al__dd-top {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--admin-border);
}
.al__dd-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0;
}
.al__dd-email {
  font-size: 0.7rem;
  color: var(--admin-muted);
  margin: 0;
}
.al__dd-link {
  display: block;
  padding: 0.62rem 1rem;
  font-size: 0.82rem;
  color: var(--admin-text);
  text-decoration: none;
  transition: background 0.15s;
}
.al__dd-link:hover {
  background: #f9fafb;
}
.al__dd-divider {
  height: 1px;
  background: var(--admin-border);
}
.al__dd-signout {
  display: block;
  width: 100%;
  padding: 0.62rem 1rem;
  font-size: 0.82rem;
  color: var(--admin-rust);
  font-weight: 600;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s;
}
.al__dd-signout:hover {
  background: rgba(var(--admin-rust-rgb), 0.05);
}

/* Content */
.al__content {
  flex: 1 1;
  padding: clamp(1.5rem, 3vw, 2rem) clamp(1.25rem, 3vw, 2.5rem);
  display: flex;
  flex-direction: column;
  gap: clamp(1.25rem, 2vw, 1.75rem);
}

/* Page head */
.al__page-head {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.al__page-title {
  font-family: var(--font-serif);
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--admin-text);
  margin: 0;
}
.al__page-sub {
  font-size: 0.88rem;
  color: var(--admin-muted);
  margin: 0;
}

/* ══════════════════════════════════════════════
   SHARED ADMIN UTILITIES
══════════════════════════════════════════════ */

/* Stat card */
.acard {
  background: #fff;
  border: 1px solid var(--admin-border);
  border-radius: 10px;
  padding: clamp(1rem, 2vw, 1.4rem);
  box-shadow: 0 1px 4px rgba(27, 27, 27, 0.05);
}

/* Status badges */
.abadge {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.22rem 0.65rem;
  border-radius: 99px;
  white-space: nowrap;
}
.abadge--new {
  background: rgba(37, 99, 235, 0.1);
  color: var(--admin-blue);
}
.abadge--reviewing {
  background: rgba(217, 119, 6, 0.12);
  color: var(--admin-amber);
}
.abadge--under-review {
  background: rgba(124, 58, 237, 0.1);
  color: var(--admin-purple);
}
.abadge--accepted {
  background: rgba(22, 163, 74, 0.1);
  color: var(--admin-green);
}
.abadge--rejected {
  background: rgba(220, 38, 38, 0.1);
  color: var(--admin-red);
}

/* Admin buttons */
.a-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-weight: 600;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
  text-decoration: none;
  border-radius: 6px;
  padding: 0.6rem 1.1rem;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.a-btn--rust {
  background: var(--admin-rust);
  color: #fff;
  border: none;
}
.a-btn--rust:hover {
  background: var(--admin-rust-dk);
  color: #fff;
}
.a-btn--outline {
  background: transparent;
  color: var(--admin-text);
  border: 1px solid var(--admin-border);
}
.a-btn--outline:hover {
  background: #f9fafb;
}
.a-btn--ghost {
  background: transparent;
  color: var(--admin-muted);
  border: none;
}
.a-btn--ghost:hover {
  background: #f3f4f6;
  color: var(--admin-text);
}

/* Mobile backdrop */
.al__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 199;
}

/* Responsive */
@media (max-width: 767.98px) {
  .al__sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    z-index: 400;
    width: min(260px, 80vw);
  }
  .al__sidebar--open {
    transform: translateX(0);
  }
  .al__main {
    margin-left: 0;
  }
  .al__topbar-menu {
    /* The one button that matters most on a phone — it opens the nav — so
       it gets a proper thumb-sized target rather than icon-sized padding. */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-left: -0.35rem;
  }
  .al__topbar-user-info {
    display: none;
  }
  .al__content {
    padding: 1rem;
  }
}

/* ── Permission access gate ── */
.al__access-loading {
  padding: 3rem;
  text-align: center;
  color: var(--admin-muted);
  font-size: 0.88rem;
}

.al__access-denied {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem;
  max-width: 420px;
  margin: 0 auto;
}
.al__access-denied-icon {
  font-size: 2.5rem;
  color: var(--admin-muted);
  margin-bottom: 1rem;
}
.al__access-denied-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--admin-text);
  margin: 0 0 0.5rem;
}
.al__access-denied-sub {
  font-size: 0.88rem;
  color: var(--admin-muted);
  line-height: 1.6;
  margin: 0;
}

/* ── Grouped sidebar (V2.1: groups fold, the nav scrolls, an icon-only rail) ── */
.al__nav { gap: 0.6rem; }
.al__nav-group { display: flex; flex-direction: column; gap: 0.12rem; }
.al__nav-items { display: flex; flex-direction: column; gap: 0.12rem; }
.al__nav-items[hidden] { display: none; }
.al__nav-group-btn {
  display: flex; align-items: center; gap: 0.45rem;
  width: 100%; margin: 0; padding: 0.4rem 0.8rem 0.3rem;
  background: none; border: 0; border-radius: 6px; cursor: pointer; text-align: left;
  font: inherit; font-size: 0.66rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
}
.al__nav-group-btn:hover:not(:disabled) { color: rgba(255, 255, 255, 0.8); background: rgba(255, 255, 255, 0.05); }
.al__nav-group-btn:disabled { cursor: default; }
.al__nav-group-btn:focus-visible, .al__nav-link:focus-visible, .al__rail-btn:focus-visible {
  outline: 2px solid var(--admin-rust-soft); outline-offset: 1px;
}
.al__nav-group-chev { font-size: 0.8rem; flex-shrink: 0; transition: transform 0.15s; }
.al__nav-group.is-folded .al__nav-group-chev { transform: rotate(-90deg); }
.al__rail-btn {
  display: flex; align-items: center; gap: 0.7rem; flex-shrink: 0;
  margin: 0.25rem 1rem 0; padding: 0.55rem 0.8rem;
  background: none; border: 0; border-top: 1px solid rgba(255, 255, 255, 0.08); cursor: pointer;
  font: inherit; font-size: 0.8rem; color: rgba(255, 255, 255, 0.5); text-align: left;
}
.al__rail-btn:hover { color: rgba(255, 255, 255, 0.85); }
.al__rail-btn svg { font-size: 1rem; flex-shrink: 0; }

/* Icon-only rail (desktop). Hover or focus shows each link's name as a tooltip. */
@media (min-width: 768px) {
  .al--rail { --admin-sidebar-w: 72px; }
  .al--rail .al__logo { justify-content: center; margin: 0 0.5rem; }
  .al--rail .al__logo-words,
  .al--rail .al__nav-text,
  .al--rail .al__sidebar-badge { display: none; }
  .al--rail .al__nav { padding: 0.25rem 0.5rem 1rem; scrollbar-gutter: auto; }
  .al--rail .al__nav-group-btn { display: none; }
  .al--rail .al__nav-group + .al__nav-group { border-top: 1px solid rgba(255, 255, 255, 0.08); padding-top: 0.5rem; }
  .al--rail .al__nav-link { justify-content: center; padding: 0.62rem 0; }
  .al--rail .al__rail-btn { justify-content: center; margin: 0.25rem 0.5rem 0; padding: 0.55rem 0; }
}
@media (max-width: 767.98px) {
  .al__rail-btn { display: none; }
}
.al__nav-group-label {
  margin: 0 0 0.15rem 0.8rem;
  font-size: 0.6rem; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase;
  color: rgba(255, 255, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminLayout.css"],"names":[],"mappings":"AAAA;;iEAEiE;AACjE;EACE,kEAAkE;EAClE,qBAAqB;EACrB,wBAAwB;EACxB;sDACoD;EACpD,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;gDAEgD;AAChD;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,iGAAiG;EACjG,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,uEAAuE;EACvE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,4BAA4B;EAC5B,6EAA6E;EAC7E,qBAAqB;EACrB,sDAAsD;EACtD,wBAAwB;AAC1B;AACA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,uBAAuB,EAAE;AAC7D,oCAAoC,qCAAqC,EAAE,kBAAkB,EAAE,sCAAsC,EAAE;AACvI,0CAA0C,oCAAoC,EAAE;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B;;eAEa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;;gDAEgD;AAChD;EACE,SAAO;EACP;;;4DAG0D;EAC1D,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA;;gDAEgD;;AAEhD,cAAc;AACd;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE;4EACwE;IACxE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA,kFAAkF;AAClF,WAAW,WAAW,EAAE;AACxB,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACtE,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACtE,yBAAyB,aAAa,EAAE;AACxC;EACE,aAAa,EAAE,mBAAmB,EAAE,YAAY;EAChD,WAAW,EAAE,SAAS,EAAE,6BAA6B;EACrD,gBAAgB,EAAE,SAAS,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB;EAClF,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACtG,gCAAgC;AAClC;AACA,0CAA0C,+BAA+B,EAAE,qCAAqC,EAAE;AAClH,8BAA8B,eAAe,EAAE;AAC/C;EACE,yCAAyC,EAAE,mBAAmB;AAChE;AACA,sBAAsB,iBAAiB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AACtF,+CAA+C,yBAAyB,EAAE;AAC1E;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,cAAc;EAC/D,sBAAsB,EAAE,uBAAuB;EAC/C,gBAAgB,EAAE,SAAS,EAAE,+CAA+C,EAAE,eAAe;EAC7F,aAAa,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,gBAAgB;AACrF;AACA,sBAAsB,gCAAgC,EAAE;AACxD,oBAAoB,eAAe,EAAE,cAAc,EAAE;;AAErD,kFAAkF;AAClF;EACE,YAAY,uBAAuB,EAAE;EACrC,sBAAsB,uBAAuB,EAAE,gBAAgB,EAAE;EACjE;;iCAE+B,aAAa,EAAE;EAC9C,qBAAqB,4BAA4B,EAAE,sBAAsB,EAAE;EAC3E,+BAA+B,aAAa,EAAE;EAC9C,4CAA4C,+CAA+C,EAAE,mBAAmB,EAAE;EAClH,0BAA0B,uBAAuB,EAAE,kBAAkB,EAAE;EACvE,0BAA0B,uBAAuB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;AACnG;AACA;EACE,gBAAgB,aAAa,EAAE;AACjC;AACA;EACE,0BAA0B;EAC1B,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACtF,+BAA+B;AACjC","sourcesContent":["/* ============================================================\n   Admin Layout — light sidebar, clean topbar, content area\n   ============================================================ */\n:root {\n  /* #e05a2b measured 3.7:1 under white button text; this is 5.4:1 */\n  --admin-rust: #b8441a;\n  --admin-rust-dk: #9a3915;\n  /* Same colour as channels, so tints can be built from it at runtime.\n     admin/brand.js repaints all three from the API. */\n  --admin-rust-rgb: 184, 68, 26;\n  --admin-rust-soft: #d0633a;\n  --admin-forest: #1a2818;\n  --admin-sidebar: #1a2818;\n  --admin-bg: #f4efe6;\n  --admin-surface: #faf7f2;\n  --admin-border: #ddd5c8;\n  --admin-text: #1b1b1b;\n  --admin-muted: #6b6258;\n  --admin-green: #16a34a;\n  --admin-amber: #d97706;\n  --admin-blue: #2563eb;\n  --admin-red: #dc2626;\n  --admin-purple: #7c3aed;\n  --admin-sidebar-w: 232px;\n  --admin-topbar-h: 64px;\n}\n\n.al {\n  display: flex;\n  min-height: 100dvh;\n  background: var(--admin-bg);\n  font-family: var(--font-body);\n}\n\n/* ══════════════════════════════════════════════\n   SIDEBAR\n══════════════════════════════════════════════ */\n.al__sidebar {\n  width: var(--admin-sidebar-w);\n  background: var(--admin-sidebar);\n  background-image: radial-gradient(ellipse at 50% 100%, rgba(56, 70, 56, 0.6) 0%, transparent 60%);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 200;\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem 0 0.5rem;\n  /* The nav scrolls, not the whole sidebar (V2.1): the logo stays put. */\n  overflow: hidden;\n  transition: width 0.2s ease;\n}\n\n.al__logo {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  text-decoration: none;\n  margin: 0 1rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.al__logo-words {\n  display: flex;\n  flex-direction: column;\n}\n.al__logo-name {\n  font-weight: 700;\n  font-size: 0.85rem;\n  letter-spacing: 0.2em;\n  color: #fff;\n  line-height: 1.1;\n}\n.al__logo-sub {\n  font-size: 0.5rem;\n  letter-spacing: 0.18em;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  line-height: 1.35;\n}\n\n.al__nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  flex: 1;\n  min-height: 0;\n  margin-top: 1rem;\n  padding: 0.25rem 0.6rem 1rem 1rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  /* A scrollbar you can see (V2.1, Page 1), thin and quiet on the dark green */\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.28) transparent;\n  scrollbar-gutter: stable;\n}\n.al__nav::-webkit-scrollbar { width: 8px; }\n.al__nav::-webkit-scrollbar-track { background: transparent; }\n.al__nav::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.22); border-radius: 8px; border: 2px solid var(--admin-sidebar); }\n.al__nav::-webkit-scrollbar-thumb:hover { background: rgba(255, 255, 255, 0.4); }\n\n.al__nav-link {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  padding: 0.62rem 0.8rem;\n  border-radius: 6px;\n  text-decoration: none;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.5);\n  transition:\n    background 0.15s,\n    color 0.15s;\n  position: relative;\n  letter-spacing: 0.01em;\n}\n.al__nav-link:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: rgba(255, 255, 255, 0.85);\n}\n.al__nav-link--active {\n  background: rgba(var(--admin-rust-rgb), 0.18);\n  color: var(--admin-rust) !important;\n  font-weight: 600;\n}\n.al__nav-link--active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 22%;\n  bottom: 22%;\n  width: 3px;\n  background: var(--admin-rust);\n  border-radius: 0 2px 2px 0;\n}\n.al__nav-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n/* Sidebar user */\n.al__sidebar-user {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.85rem 0.5rem;\n  margin-top: auto;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.al__sidebar-avatar {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.72rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0.03em;\n}\n\n.al__sidebar-user-name {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 0;\n}\n.al__sidebar-user-role {\n  font-size: 0.62rem;\n  color: rgba(255, 255, 255, 0.4);\n  margin: 0;\n}\n.al__sidebar-user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.al__sidebar-user-chevron {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.35);\n  font-size: 0.6rem;\n  padding: 0.2rem;\n  flex-shrink: 0;\n}\n.al__sidebar-user-chevron:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.al__sidebar-badge {\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n  scale: 0.8;\n}\n\n/* ══════════════════════════════════════════════\n   MAIN AREA\n══════════════════════════════════════════════ */\n.al__main {\n  flex: 1;\n  /* A flex item's min-width is `auto`, which means \"never narrower than my\n     widest unbreakable content\". One long line inside a card was enough to\n     push the whole page wider than a tablet screen and put the row's\n     buttons out of reach, so this lets it shrink instead. */\n  min-width: 0;\n  margin-left: var(--admin-sidebar-w);\n  display: flex;\n  flex-direction: column;\n  min-height: 100dvh;\n}\n\n/* Topbar */\n.al__topbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: #fff;\n  border-bottom: 1px solid var(--admin-border);\n  height: var(--admin-topbar-h);\n  display: flex;\n  align-items: center;\n  padding: 0 clamp(1rem, 3vw, 2rem);\n  gap: 1rem;\n}\n\n.al__topbar-menu {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: var(--admin-text);\n  padding: 0.25rem;\n  flex-shrink: 0;\n}\n\n.al__topbar-spacer {\n  flex: 1;\n}\n\n/* Bell */\n.al__topbar-bell {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text);\n  font-size: 1.1rem;\n  text-decoration: none;\n  padding: 0.35rem;\n  transition: color 0.15s;\n}\n.al__topbar-bell:hover {\n  color: var(--admin-rust);\n}\n.al__bell-badge {\n  position: absolute;\n  top: -3px;\n  right: -3px;\n  background: var(--admin-rust);\n  color: #fff;\n  font-size: 0.52rem;\n  font-weight: 700;\n  min-width: 1rem;\n  height: 1rem;\n  border-radius: 99px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.2rem;\n}\n\n/* Topbar user */\n.al__topbar-user {\n  position: relative;\n}\n\n.al__topbar-user-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n}\n\n.al__topbar-avatar {\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 50%;\n  background: var(--admin-forest);\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  /* Slight gradient */\n  background: linear-gradient(135deg, #4a5e42 0%, var(--admin-forest) 100%);\n}\n\n.al__topbar-avatar--lg {\n  width: 2.6rem;\n  height: 2.6rem;\n  font-size: 0.82rem;\n}\n\n.al__topbar-user-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.al__topbar-user-name {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  line-height: 1.2;\n}\n.al__topbar-user-role {\n  font-size: 0.72rem;\n  color: var(--admin-muted);\n  line-height: 1.2;\n}\n\n.al__topbar-chevron {\n  font-size: 0.65rem;\n  color: var(--admin-muted);\n  transition: transform 0.2s;\n}\n\n/* Dropdown */\n.al__profile-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  min-width: 220px;\n  overflow: hidden;\n  z-index: 300;\n}\n.al__dd-top {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid var(--admin-border);\n}\n.al__dd-name {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0;\n}\n.al__dd-email {\n  font-size: 0.7rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n.al__dd-link {\n  display: block;\n  padding: 0.62rem 1rem;\n  font-size: 0.82rem;\n  color: var(--admin-text);\n  text-decoration: none;\n  transition: background 0.15s;\n}\n.al__dd-link:hover {\n  background: #f9fafb;\n}\n.al__dd-divider {\n  height: 1px;\n  background: var(--admin-border);\n}\n.al__dd-signout {\n  display: block;\n  width: 100%;\n  padding: 0.62rem 1rem;\n  font-size: 0.82rem;\n  color: var(--admin-rust);\n  font-weight: 600;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.al__dd-signout:hover {\n  background: rgba(var(--admin-rust-rgb), 0.05);\n}\n\n/* Content */\n.al__content {\n  flex: 1;\n  padding: clamp(1.5rem, 3vw, 2rem) clamp(1.25rem, 3vw, 2.5rem);\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.25rem, 2vw, 1.75rem);\n}\n\n/* Page head */\n.al__page-head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n.al__page-title {\n  font-family: var(--font-serif);\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: var(--admin-text);\n  margin: 0;\n}\n.al__page-sub {\n  font-size: 0.88rem;\n  color: var(--admin-muted);\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════\n   SHARED ADMIN UTILITIES\n══════════════════════════════════════════════ */\n\n/* Stat card */\n.acard {\n  background: #fff;\n  border: 1px solid var(--admin-border);\n  border-radius: 10px;\n  padding: clamp(1rem, 2vw, 1.4rem);\n  box-shadow: 0 1px 4px rgba(27, 27, 27, 0.05);\n}\n\n/* Status badges */\n.abadge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.22rem 0.65rem;\n  border-radius: 99px;\n  white-space: nowrap;\n}\n.abadge--new {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--admin-blue);\n}\n.abadge--reviewing {\n  background: rgba(217, 119, 6, 0.12);\n  color: var(--admin-amber);\n}\n.abadge--under-review {\n  background: rgba(124, 58, 237, 0.1);\n  color: var(--admin-purple);\n}\n.abadge--accepted {\n  background: rgba(22, 163, 74, 0.1);\n  color: var(--admin-green);\n}\n.abadge--rejected {\n  background: rgba(220, 38, 38, 0.1);\n  color: var(--admin-red);\n}\n\n/* Admin buttons */\n.a-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  font-weight: 600;\n  font-size: 0.82rem;\n  letter-spacing: 0.02em;\n  text-decoration: none;\n  border-radius: 6px;\n  padding: 0.6rem 1.1rem;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n.a-btn--rust {\n  background: var(--admin-rust);\n  color: #fff;\n  border: none;\n}\n.a-btn--rust:hover {\n  background: var(--admin-rust-dk);\n  color: #fff;\n}\n.a-btn--outline {\n  background: transparent;\n  color: var(--admin-text);\n  border: 1px solid var(--admin-border);\n}\n.a-btn--outline:hover {\n  background: #f9fafb;\n}\n.a-btn--ghost {\n  background: transparent;\n  color: var(--admin-muted);\n  border: none;\n}\n.a-btn--ghost:hover {\n  background: #f3f4f6;\n  color: var(--admin-text);\n}\n\n/* Mobile backdrop */\n.al__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 199;\n}\n\n/* Responsive */\n@media (max-width: 767.98px) {\n  .al__sidebar {\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    z-index: 400;\n    width: min(260px, 80vw);\n  }\n  .al__sidebar--open {\n    transform: translateX(0);\n  }\n  .al__main {\n    margin-left: 0;\n  }\n  .al__topbar-menu {\n    /* The one button that matters most on a phone — it opens the nav — so\n       it gets a proper thumb-sized target rather than icon-sized padding. */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    margin-left: -0.35rem;\n  }\n  .al__topbar-user-info {\n    display: none;\n  }\n  .al__content {\n    padding: 1rem;\n  }\n}\n\n/* ── Permission access gate ── */\n.al__access-loading {\n  padding: 3rem;\n  text-align: center;\n  color: var(--admin-muted);\n  font-size: 0.88rem;\n}\n\n.al__access-denied {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 4rem 2rem;\n  max-width: 420px;\n  margin: 0 auto;\n}\n.al__access-denied-icon {\n  font-size: 2.5rem;\n  color: var(--admin-muted);\n  margin-bottom: 1rem;\n}\n.al__access-denied-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--admin-text);\n  margin: 0 0 0.5rem;\n}\n.al__access-denied-sub {\n  font-size: 0.88rem;\n  color: var(--admin-muted);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ── Grouped sidebar (V2.1: groups fold, the nav scrolls, an icon-only rail) ── */\n.al__nav { gap: 0.6rem; }\n.al__nav-group { display: flex; flex-direction: column; gap: 0.12rem; }\n.al__nav-items { display: flex; flex-direction: column; gap: 0.12rem; }\n.al__nav-items[hidden] { display: none; }\n.al__nav-group-btn {\n  display: flex; align-items: center; gap: 0.45rem;\n  width: 100%; margin: 0; padding: 0.4rem 0.8rem 0.3rem;\n  background: none; border: 0; border-radius: 6px; cursor: pointer; text-align: left;\n  font: inherit; font-size: 0.66rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.45);\n}\n.al__nav-group-btn:hover:not(:disabled) { color: rgba(255, 255, 255, 0.8); background: rgba(255, 255, 255, 0.05); }\n.al__nav-group-btn:disabled { cursor: default; }\n.al__nav-group-btn:focus-visible, .al__nav-link:focus-visible, .al__rail-btn:focus-visible {\n  outline: 2px solid var(--admin-rust-soft); outline-offset: 1px;\n}\n.al__nav-group-chev { font-size: 0.8rem; flex-shrink: 0; transition: transform 0.15s; }\n.al__nav-group.is-folded .al__nav-group-chev { transform: rotate(-90deg); }\n.al__rail-btn {\n  display: flex; align-items: center; gap: 0.7rem; flex-shrink: 0;\n  margin: 0.25rem 1rem 0; padding: 0.55rem 0.8rem;\n  background: none; border: 0; border-top: 1px solid rgba(255, 255, 255, 0.08); cursor: pointer;\n  font: inherit; font-size: 0.8rem; color: rgba(255, 255, 255, 0.5); text-align: left;\n}\n.al__rail-btn:hover { color: rgba(255, 255, 255, 0.85); }\n.al__rail-btn svg { font-size: 1rem; flex-shrink: 0; }\n\n/* Icon-only rail (desktop). Hover or focus shows each link's name as a tooltip. */\n@media (min-width: 768px) {\n  .al--rail { --admin-sidebar-w: 72px; }\n  .al--rail .al__logo { justify-content: center; margin: 0 0.5rem; }\n  .al--rail .al__logo-words,\n  .al--rail .al__nav-text,\n  .al--rail .al__sidebar-badge { display: none; }\n  .al--rail .al__nav { padding: 0.25rem 0.5rem 1rem; scrollbar-gutter: auto; }\n  .al--rail .al__nav-group-btn { display: none; }\n  .al--rail .al__nav-group + .al__nav-group { border-top: 1px solid rgba(255, 255, 255, 0.08); padding-top: 0.5rem; }\n  .al--rail .al__nav-link { justify-content: center; padding: 0.62rem 0; }\n  .al--rail .al__rail-btn { justify-content: center; margin: 0.25rem 0.5rem 0; padding: 0.55rem 0; }\n}\n@media (max-width: 767.98px) {\n  .al__rail-btn { display: none; }\n}\n.al__nav-group-label {\n  margin: 0 0 0.15rem 0.8rem;\n  font-size: 0.6rem; font-weight: 700; letter-spacing: 0.18em; text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
